import { IntlFormatters, defineMessages } from 'react-intl';
import { get } from 'lodash';

export const messages = defineMessages({
  'estimate.value': {
    id: '{{estimate.value}}',
    defaultMessage: 'Estimate Value',
  },
  'patient.balance': {
    id: 'utils.utilsSquigglies.patient.balance',
    defaultMessage: 'Patient Balance',
  },
  'appointment.date': {
    id: 'utils.utilsSquigglies.appointment.date',
    defaultMessage: 'Appointment Date',
  },
  'appointment.longdate': {
    id: 'utils.utilsSquigglies.appointment.longdate',
    defaultMessage: 'Appointment Long Date',
  },
  'appointment.duration': {
    id: 'utils.utilsSquigglies.appointment.duration',
    defaultMessage: 'Appointment Duration',
  },
  'appointment.status': {
    id: 'utils.utilsSquigglies.appointment.status',
    defaultMessage: 'Appointment Status',
  },
  cancelledAppointmentsListInDay: {
    id: 'cancelledAppointmentsListInDay',
    defaultMessage: 'Cancelled Appointments List In Day',
  },
  'facility.address': {
    id: 'utils.utilsSquigglies.facility.address',
    defaultMessage: 'Facility Address',
  },
  'facility.name': {
    id: 'utils.utilsSquigglies.facility.name',
    defaultMessage: 'Facility Name',
  },
  'facility.phone': {
    id: 'utils.utilsSquigglies.facility.phone',
    defaultMessage: 'Facility Phone',
  },
  'facility.alternativePhone': {
    id: 'utils.utilsSquigglies.facility.alternativePhone',
    defaultMessage: 'Facility Alternative Phone',
  },
  'facility.specialInstructions': {
    id: 'utils.utilsSquigglies.facility.specialInstructions',
    defaultMessage: 'Facility Special Instructions',
  },
  'me.name': {
    id: 'utils.utilsSquigglies.me.name',
    defaultMessage: 'Your Name',
  },
  'patient.firstname': {
    id: 'utils.utilsSquigglies.patient.firstname',
    defaultMessage: 'Patient Name',
  },
  'provider.name': {
    id: 'utils.utilsSquigglies.provider.name',
    defaultMessage: 'Provider Name',
  },
  'provider.specialInstructions': {
    id: 'utils.utilsSquigglies.provider.specialInstructions',
    defaultMessage: 'Provider Special Instructions',
  },
  'system.url.insuranceUrl': {
    id: 'utils.utilsSquigglies.system.url.insuranceUrl',
    defaultMessage: 'Insurance Upload Link',
  },
  'system.url.appointmentChecklist': {
    id: 'utils.utilsSquigglies.system.url.appointmentChecklist',
    defaultMessage: 'Appointment Checklist',
  },
  'system.url.reminder.confirm': {
    id: 'utils.utilsSquigglies.system.url.reminder.confirm',
    defaultMessage: 'Reminder Confirm Link',
  },
  'system.url.selfScheduleUrl': {
    id: 'utils.utilsSquigglies.system.url.selfScheduleUrl',
    defaultMessage: 'Self Schedule Link',
  },
  'system.url.chatUrl': {
    id: 'utils.utilsSquigglies.system.url.chatUrl',
    defaultMessage: 'Secure Chat Link',
  },
  'recall.date': {
    id: 'utils.utilsSquigglies.recall.date',
    defaultMessage: 'Recall Date',
  },
  'recall.monthandyear': {
    id: 'utils.utilsSquigglies.recall.monthandyear',
    defaultMessage: 'Recall Month and Year',
  },
  'appointmentType.name': {
    id: 'utils.utilsSquigglies.appointmentType.name',
    defaultMessage: 'Appointment Type',
  },
  'appointmentType.specialInstructions': {
    id: 'utils.utilsSquigglies.appointmentType.specialInstructions',
    defaultMessage: 'Appointment Type Special Instructions',
  },
  'futureAppointment.date': {
    id: 'utils.utilsSquigglies.futureAppointment.date',
    defaultMessage: 'Future Appointment Date',
  },
  'futureAppointment.longdate': {
    id: 'utils.utilsSquigglies.futureAppointment.longdate',
    defaultMessage: 'Future Appointment Long Date',
  },
  'availability.date': {
    id: 'utils.utilsSquigglies.availability.date',
    defaultMessage: 'Availability Date',
  },
  'doNotContactMessage.text': {
    id: 'utils.utilsSquigglies.doNotContactMessage.text',
    defaultMessage: 'Do Not Contact Text',
  },
  'facility.alternativeName': {
    id: 'utils.utilsSquigglies.facility.alternativeName',
    defaultMessage: 'Facility Alternative Name',
  },
  'facility.phonetic': {
    id: 'utils.utilsSquigglies.facility.phonetic',
    defaultMessage: 'Facility Phonetic Name',
  },
  'message.text': {
    id: 'utils.utilsSquigglies.message.text',
    defaultMessage: 'Message',
  },
  'offer._id': {
    id: 'utils.utilsSquigglies.offer._id',
    defaultMessage: 'Offer Id',
  },
  'system.url.patientFormUrl': {
    id: 'utils.utilsSquigglies.system.url.patientFormUrl',
    defaultMessage: 'Patient Intake Form',
  },
  'patient.name': {
    id: 'utils.utilsSquigglies.patient.name',
    defaultMessage: 'Patient Name',
  },
  'patient.lastname': {
    id: 'utils.utilsSquigglies.patient.lastname',
    defaultMessage: 'Patient Last Name',
  },
  'patient._id': {
    id: 'utils.utilsSquigglies.patient._id',
    defaultMessage: 'Patient Id',
  },
  'referral.calledAtDate': {
    id: 'utils.utilsSquigglies.referral.calledAtDate',
    defaultMessage: 'Referral Call Date',
  },
  'referral.referringProvider': {
    id: 'utils.utilsSquigglies.referral.referringProvider',
    defaultMessage: 'Referral Doctor Name',
  },
  'user._id': {
    id: 'utils.utilsSquigglies.user._id',
    defaultMessage: 'User Id',
  },
  'user.name': {
    id: 'utils.utilsSquigglies.user.name',
    defaultMessage: 'User Name',
  },
  'user.email': {
    id: 'utils.utilsSquigglies.user.email',
    defaultMessage: 'User Email',
  },
  'user.settings.cancellation.expiration': {
    id: 'utils.utilsSquigglies.user.settings.cancellation.expiration',
    defaultMessage: 'Cancellation Expiration Time',
  },
  'waitlist._id': {
    id: 'utils.utilsSquigglies.waitlist._id',
    defaultMessage: 'Waitlist Id',
  },
  'groupInvite.group.name': {
    id: 'utils.utilsSquigglies.groupInvite.group.name',
    defaultMessage: 'Invite Group Name',
  },
  'system.url.groupInvite.invite': {
    id: 'utils.utilsSquigglies.system.url.groupInvite.invite',
    defaultMessage: 'Group Invitation Link',
  },
  'system.contact.value': {
    id: 'utils.utilsSquigglies.system.contact.value',
    defaultMessage: 'System Contact value',
  },
  'system.referral.inboundNumber': {
    id: 'utils.utilsSquigglies.system.referral.inboundNumber',
    defaultMessage: 'Referral Inbound Number',
  },
  'system.url.offer.value': {
    id: 'utils.utilsSquigglies.system.url.offer.value',
    defaultMessage: 'Availability Offer Link',
  },
  'system.url.filesPage': {
    id: 'utils.utilsSquigglies.system.url.filesPage',
    defaultMessage: 'Patient Files Link',
  },
  'system.url.appointment.decline': {
    id: 'utils.utilsSquigglies.system.url.appointment.decline',
    defaultMessage: 'Appointment Schedule Cancellation Link',
  },
  'system.url.appointment.confirm': {
    id: 'utils.utilsSquigglies.system.url.appointment.confirm',
    defaultMessage: 'Appointment Schedule Confirmation Link',
  },
  'system.url.reminder.cancel': {
    id: 'utils.utilsSquigglies.system.url.reminder.cancel',
    defaultMessage: 'Reminder Cancel Link',
  },
  'system.url.referral.cancel': {
    id: 'utils.utilsSquigglies.system.url.referral.cancel',
    defaultMessage: 'Referral Cancellation link',
  },
  'system.url.referral.schedule': {
    id: 'utils.utilsSquigglies.system.url.referral.schedule',
    defaultMessage: 'Referral Schedule Link',
  },
  'system.url.referralUrl': {
    id: 'utils.utilsSquigglies.system.url.referralUrl',
    defaultMessage: 'Referral Page Link',
  },
  'system.url.scoreFeedbackUrl': {
    id: 'utils.utilsSquigglies.system.url.scoreFeedbackUrl',
    defaultMessage: 'Score Feedback Link',
  },
  'system.url.positiveFeedbackUrl': {
    id: 'utils.utilsSquigglies.system.url.positiveFeedbackUrl',
    defaultMessage: 'Positive Feedback Link',
  },
  'system.url.negativeFeedbackUrl': {
    id: 'utils.utilsSquigglies.system.url.negativeFeedbackUrl',
    defaultMessage: 'Negative Feedback Link',
  },
  'system.url.feedbackPromoterType': {
    id: 'utils.utilsSquigglies.system.url.feedbackPromoterType',
    defaultMessage: 'Feedback Promoter Link',
  },
});

/**
 * Returns the squiggly name or message
 * @category Getters
 * @category Squiggly
 */
export const getSquigglyName = (
  id: string,
  formatMessage: IntlFormatters['formatMessage'],
) => {
  const messageId = id.replace(/{|}|( \| .*)/g, '');
  const message = get(messages, messageId);
  return message ? formatMessage(message) : messageId;
};
